import { PaymentLogStatus, ProductCode } from '@dev/ee-api/ee-api-models';
import { identity, includes, isEmpty, pickBy } from 'lodash-es';
import { useSelector } from 'react-redux';

import dayjs from '../../../services/tools/dayjs';
import { getProductStore } from '../../../store/products/actions';

interface UsePaymmentErrorInterface {
    anyPaymentError: boolean;
    paymentErrorPerProduct: Record<ProductCode, boolean>;
}

const paymentErrorStatuses = [PaymentLogStatus.Declined, PaymentLogStatus.Error, PaymentLogStatus.Incomplete];

/**
 * product will have error set to `true` if `isTrial=false`, have `ActivePlanDetails` and have payment status other than Approved.
 *
 * @returns object with `anyPaymentError` and `paymentErrorPerProduct`
 */
export const usePaymentError = (): UsePaymmentErrorInterface => {
    const { dashboards } = useSelector(getProductStore);

    const paymentErrorPerProduct = [...(dashboards || [])]?.reduce((acc, plan) => {
        const subscriptionDate = dayjs(plan?.ActivePlanDetails?.NextBillingDate);
        const daysToSubscriptionEnd = subscriptionDate.diff(dayjs(), 'day', true);
        const canRenew =
            !plan?.ActivePlanDetails?.IsSubscriptionBased ||
            (plan?.ActivePlanDetails?.IsSubscriptionBased &&
                !isEmpty(plan?.ActivePlanDetails?.NextBillingDate) &&
                daysToSubscriptionEnd <= 2 &&
                daysToSubscriptionEnd > 0);
        return {
            ...acc,
            [plan.Code]:
                canRenew &&
                !(plan?.ActivePlanDetails?.IsTrial || plan?.ActivePlanDetails?.IsFree) &&
                plan?.ActivePlanDetails?.IsActive &&
                includes(paymentErrorStatuses, plan?.ActivePlanDetails?.PaymentStatus),
        };
    }, {} as Record<ProductCode, boolean>);

    const anyPaymentError = !isEmpty(pickBy(paymentErrorPerProduct, identity));

    return { anyPaymentError, paymentErrorPerProduct };
};
